<template>
  <div :style="myBlockProps.getStyles(visible)" v-touch:swipe.right="previousItem" v-touch:swipe.left="nextItem">
    <dynamic-block v-for="child in children" :key="child.properties.guid" :ref="child.properties.guid" :block="child"
                   :visible="isVisible(child.properties.guid)"/>
  </div>
</template>

<script>
import ContentBlock from '../ContentBlock.vue';
import DynamicBlock from '../DynamicBlock.vue';

export default {
  name: 'paginable-content-block',
  components: { DynamicBlock },
  extends: ContentBlock,
  methods: {
    isVisible(guid) {
      return this.selectedLinkId === guid;
    },
    scrollToTop() {
      this.$el.scrollTop = 0;
    },
    async nextItem() {
      if (!this.hasPaginableChildren && !this.hasScrollableChildren) {
        const currentItemIndex = this.browserItemsOrder.indexOf(this.selectedLinkId);
        const nextItemIndex = Math.min(currentItemIndex + 1, this.browserItemsOrder.length - 1);
        const newSelectedId = this.browserItemsOrder[nextItemIndex];
        await this.$store.dispatch('setSelectedBlock', { containerGuid: this.guid, selectedGuid: newSelectedId });
      }
    },
    async previousItem() {
      if (!this.hasPaginableChildren && !this.hasScrollableChildren) {
        const currentItemIndex = this.browserItemsOrder.indexOf(this.selectedLinkId);
        const previousItemIndex = Math.max(currentItemIndex - 1, 0);
        const newSelectedId = this.browserItemsOrder[previousItemIndex];
        await this.$store.dispatch('setSelectedBlock', { containerGuid: this.guid, selectedGuid: newSelectedId });
      }
    }
  },
  watch: {
    selectedLinkId() {
      this.scrollToTop();
    }
  }
};
</script>
